import React, { useRef, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Pages from "./pages";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "./redux/action";
import jwt_decode from "jwt-decode";

//Aos
import Aos from "aos";
import "aos/dist/aos.css";

//hooks
import ScrollToTheTop from "./hooks/ScrollToTheTop";

// Redux
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { Alert } from "./components/Layout/Alert";

// Currency Context
import { CurrencyProvider } from "./contexts/CurrencyContext";

function App() {
  let app = useRef(null);

  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <div className="root-div" ref={(el) => (app = el)}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <CurrencyProvider>
            <Router>
              <Alert />
              <ScrollToTheTop />

              {/* WhatsApp Floating Button */}
              <a
                href="https://wa.me/6281313102065"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  position: "fixed",
                  bottom: "24px",
                  left: "24px",
                  zIndex: 9999,
                  backgroundColor: "#25D366",
                  borderRadius: "50%",
                  width: "56px",
                  height: "56px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                  textDecoration: "none",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 32 32"
                  width="32"
                  height="32"
                  fill="white"
                >
                  <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.736 5.472 2.027 7.775L0 32l8.469-2.004A15.94 15.94 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.771-1.854l-.486-.289-5.028 1.189 1.215-4.897-.317-.502A13.267 13.267 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.274-9.874c-.398-.199-2.356-1.162-2.72-1.295-.364-.133-.629-.199-.894.199-.265.398-1.028 1.295-1.26 1.56-.232.265-.464.298-.862.1-.398-.199-1.681-.62-3.202-1.976-1.183-1.057-1.982-2.362-2.214-2.76-.232-.398-.025-.613.175-.811.18-.178.398-.464.597-.696.199-.232.265-.398.398-.663.133-.265.066-.497-.033-.696-.1-.199-.894-2.155-1.225-2.951-.322-.774-.649-.669-.894-.681l-.762-.013c-.265 0-.696.1-1.061.497-.364.398-1.393 1.362-1.393 3.318 0 1.956 1.426 3.846 1.625 4.111.199.265 2.806 4.285 6.798 6.012.95.41 1.692.655 2.269.838.954.303 1.822.26 2.509.158.765-.114 2.356-.963 2.688-1.893.332-.93.332-1.727.232-1.893-.1-.166-.364-.265-.762-.464z" />
                </svg>
              </a>
              <Pages />
            </Router>
          </CurrencyProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
